// TateSocialApp/client/src/components/Chat/ChatMessages/MessageActions.js

import React from 'react';
import PropTypes from 'prop-types';

const MessageActions = ({ onReply, onReact }) => {
    return (
        <div className="message-actions">
            <div className="dropdown">
                <button
                    className="message-menu-button"
                    title="Message options"
                    aria-label="Message options"
                >
                    ⋯
                </button>
                <div className="dropdown-content">
                    <div onClick={onReply}>Reply</div>
                    <div>Edit</div>
                    <div onClick={onReact}>React</div>
                </div>
            </div>
        </div>
    );
};

MessageActions.propTypes = {
    onReply: PropTypes.func,
    onReact: PropTypes.func.isRequired
};

export default MessageActions;
